import { TopNavigationLandingPage } from 'components/header/topNavigationLandingPage/TopNavigationLandingPage'
import { Icon } from 'components/icon'
import { Layout } from 'components/layout/Layout'
import { HStack, Stack } from 'components/Stack'
import { Title_h4_default } from 'components/Typography'
import { FC } from 'react'
import {
  SBlock,
  SCaption,
  SPicture,
  SSocialHStack,
  STitle,
  STitleSocialStack,
} from './MaintenancePage.styled'

export const MaintenancePage: FC = () => {
  const caption = <SCaption>Scheduled maintenance</SCaption>

  const titleAndSocials = (
    <STitleSocialStack space={32}>
      <STitle variant={Title_h4_default}>
        We're working to make the GoodTrust experience even better and appreciate your patience.
        Please come back soon as it won't take long.
      </STitle>
      <SSocialHStack space={'1.75rem'}>
        <a target="_blank" rel="noreferrer" href="https://www.facebook.com/mygoodtrust">
          <Icon name="Facebook" size="1.2rem" />
        </a>
        <a target="_blank" rel="noreferrer" href="https://www.linkedin.com/company/goodtrust/">
          <Icon name="LinkedIn" size="1.2rem" />
        </a>
        <a target="_blank" rel="noreferrer" href="https://twitter.com/MyGoodTrust">
          <Icon name="Twitter" size="1.2rem" />
        </a>
        <a target="_blank" rel="noreferrer" href="https://www.instagram.com/mygoodtrust/">
          <Icon name="Instagram" size="1.2rem" />
        </a>
      </SSocialHStack>
    </STitleSocialStack>
  )

  const picture = <SPicture imageKey="illustrations/goodtrust-network" css={{}} />

  return (
    <Layout header={<TopNavigationLandingPage variant="general-info" hideNavigation />}>
      <SBlock>
        <div className="mobile-only">
          <Stack space={'0.5rem'} css={{ alignItems: 'center' }}>
            {caption}
            {picture}
            {titleAndSocials}
          </Stack>
        </div>
        <div className="desktop-only">
          <HStack space={[0, '1rem', '5.75rem']}>
            <Stack space={'0.5rem'}>
              {caption}
              {titleAndSocials}
            </Stack>
            {picture}
          </HStack>
        </div>
      </SBlock>
    </Layout>
  )
}
